import {Component, Input, OnInit} from '@angular/core';
import {CheckoutService} from '../checkout.service';
import {WalletService} from '../../wallet/wallet.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CartService} from '../../cart/cart.service';
import {PaypalService} from './PaypalService';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {PaymentInformationService} from '../../settings/payment-information/payment-information.service';
import {DialogService} from '../../../../service/dialog.service';
import {Location} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {getPayPalClientId} from '../../../../environments/environment';

@Component({
  selector: 'app-paypal-native',
  templateUrl: './paypal-native.component.html',
  styleUrls: ['./paypal-native.component.scss']
})
export class PaypalNativeComponent implements OnInit {
  @Input() id: string;
  subscriptionId: string;
  private ids: string[] = [];
  private firstPayment = true;
  loading = true;

  constructor(private walletService: WalletService,
              private router: Router,
              private cartService: CartService,
              private location: Location,
              private paymentService: PaymentInformationService,
              private translateService: TranslateService,
              private dialogService: DialogService,
              private route: ActivatedRoute,
              private paypalService: PaypalService,
              public checkoutService: CheckoutService) { }


  ngOnInit(): void {
    if (this.id) {
      this.ids.push(this.id);
      this.payNext();
      return;
    }

    this.subscriptionId = this.route.snapshot.queryParams.subscriptionId;

    if (this.subscriptionId) {
      this.updateSubscription(this.paymentService.updateSubscription(this.subscriptionId));
      return;
    }

    const { request } =
      this.checkoutService.selectedPaymentRequest.value;
    request()
      .pipe(
        tap(() =>
          this.checkoutService.refreshCheckout({ paymentType: "CREDIT_CARD" })
        )).subscribe(response => {
          if (response.productClientSecret) {
            this.fetchId(response.productClientSecret);
          }
          if (response.clientSecret) {
            this.fetchId(response.clientSecret);
          }
          if (response.clientSecretProductPrice) {
            this.fetchId(response.clientSecretProductPrice);
          }
          this.payNext();
        }, err => {
          this.dialogService.showErrorDialog(err.message).subscribe(() => {
            this.location.back();
          });
    });

  }
  private initiatePaypal(extraActions: any, isSubscription: boolean) {
    this.loading = true;
    this.paypalService.initiateByLocale(getPayPalClientId(), isSubscription, this.getLocale()).subscribe(
      () => {
        this.loading = false;

        const actions = {
          ...extraActions,
          onError: (err: any) => this.onError(err),
        };
        // @ts-ignore
        paypal.Buttons(actions).render('#paypal-button-container');
      }
    );
  }

  private getLocale() {
    const current = this.translateService.currentLang;
    if (current == 'en' || !current) {
      return 'en_GB';
    }
    return current + "_" + current.toUpperCase();
  }

  private updateSubscription(promise: Promise<string>) {
    this.initiatePaypal({
          createSubscription: () => promise,
          onApprove: (data) => {
            this.checkoutService.sendSubscriptionApprovedForUpdate(data.subscriptionID).subscribe();
            this.dialogService.showSuccessDialog("PAYMENT_METHOD_UPDATED");
            this.router.navigate(["../../../"], {relativeTo: this.route});
          }
        }, true);
  }

  private subscribeById(id: string) {
    this.initiatePaypal({
      createSubscription: () => this.getIdByPromise(id),
      onApprove: (data) => this.onApprove(this.checkoutService.sendSubscriptionApproved(data.subscriptionID))
    }, true);
  }

  onApprove(approveRequest: Observable<any>) {
    if (this.id) {
      this.router.navigate(["/247eTdOJWxFtMRNunNJgx1nrKxd6HHsS"], {
        queryParams: { approved: true },
      });
      return;
    }
    this.firstPayment = false;
    approveRequest.subscribe();
    if (this.ids.length <= 1) {
      const { routerLink, queryParams, afterSuccess, afterCloseDialog } =
        this.checkoutService.selectedPaymentRequest.value;
      this.cartService.removeAllProductFromCart();
      this.walletService.syncWalletBalance();
      this.checkoutService.checkout.next(null);
      afterSuccess();
      afterCloseDialog();
      this.router.navigate([routerLink], {
        relativeTo: this.route,
        queryParams,
      });
      return;
    } else if (!this.firstPayment) {
      if (this.ids[1].includes("-")) {
        this.dialogService.showOneMoreSubscriptionDialog().subscribe();
      } else {
        this.dialogService.showOneMoreCheckoutDialog().subscribe();
      }
    }
    this.ids = this.ids.slice(1);
    this.payNext();
  }
  onError(err: any) {
    if (this.id) {
      this.router.navigate(["/247eTdOJWxFtMRNunNJgx1nrKxd6HHsS"], {
        queryParams: { approved: false },
      });
      return;
    }
    this.checkoutService.selectedShipment = null;
    this.dialogService.showErrorDialog(err?.message);
    // this.showError = true;
  }

  private getIdByPromise(id: string) {
    return new Promise((resolveOuter) => {
      resolveOuter(
        new Promise((resolveInner) => {
          setTimeout(resolveInner, 100);
        }),
      );
    }).then(() => id);
  }

  private payNext() {
    const id = this.ids[0];
    if (id.includes("-")) {
      this.subscribeById(id);
    } else {
      this.payOrder(id);
    }
  }

  private payOrder(id: string) {
      this.initiatePaypal({
        createOrder: () => this.getIdByPromise(id),
        onApprove: (data) => this.onApprove(this.checkoutService.sendCheckoutApproved(data.orderID))
      }, false);
  }

  private fetchId(data: string) {
    const startIndex = data.indexOf("\"id\":");
    const endIndex = data.indexOf(",", data.indexOf("\"id\":"));
    if (startIndex < 0 || endIndex < 0) { return null; }
    const id = data.substring(startIndex + 6, endIndex - 1);
    if (id != null) { this.ids.push(id); }
  }
}
